import { BigNumber } from 'ethers'

export const distribution = [
  {
    account: '0x9b616Ac1D31F17Be9B23560d93699cA7732e2808',
    amount: BigNumber.from('1250000000000000000'),
  },
  {
    account: '0xbB637a937E864795cb00f6681661904836aC8a59',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x0998160bdF3Ff6D86A4E9D5c31e0eFC3Ca7e7D01',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x7E2f6E2f86089Ae708425BcA2E7Bf43ad5cA486E',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x6477241A2Aa2742e2bd19A4374D9Cbd6d78A3d31',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xF0F32C3c8DEf7b43caA14fEd5752AbC5381C8374',
    amount: BigNumber.from('2482082051282050000'),
  },
  {
    account: '0x5EAC09dc8987309F53e72A761EA60b448F3224dD',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x90E1F595Abc8D731cf82031c974aDD334B84b29E',
    amount: BigNumber.from('14423440485571000000'),
  },
  {
    account: '0x573e4F4537aC28796a79598600018A77c070A6a0',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xf286E07ED6889658A3285C05C4f736963cF41456',
    amount: BigNumber.from('458810880000000000'),
  },
  {
    account: '0x8e3FAbF5A1E4B773C227d2646EB2470263D3a1bF',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x28d804Bf2212E220BC2B7B6252993Db8286dF07f',
    amount: BigNumber.from('5897745128205130000'),
  },
  {
    account: '0xddC60D163015CF5Ca1369D557A2ca1cC2de1F1e3',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x81c4b663fF7261e10057bd47E333b0041d58fa54',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xBb00900B914C71D7CC0d6c8865359499B9d0b3B6',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x57A0575339B2A3559Ee840853Bd932050AAD9266',
    amount: BigNumber.from('1861200000000000000'),
  },
  {
    account: '0x1d5E65a087eBc3d03a294412E46CE5D6882969f4',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x29832De0D33DFEa039A2a4251eaf14c8a6ddbCdF',
    amount: BigNumber.from('1091948000000000000'),
  },
  {
    account: '0x6Bb813898731f9c016cB8453baf9bfb301a3b650',
    amount: BigNumber.from('769520000000000000'),
  },
  {
    account: '0x336d4aFD4c1e0B82a2Bb38859C234c54eDF0a983',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x2875F367B4c6c07Ca72568A9b0D0887A37f06b24',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x1Ec2C4e7Fff656f76c5A4992bd5efA7e7fF1A460',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0x35dcf2c2223F335266e17dacBE8777D7C5bF8A15',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0x68057266b9e20A60C55D7b50Eb6f22117b1Eb842',
    amount: BigNumber.from('4469014102564100000'),
  },
  {
    account: '0xF63266A34d848f35B4513aEE8847d8F3DD03A905',
    amount: BigNumber.from('1091948000000000000'),
  },
  {
    account: '0xD72708E95577F80056Fd6A44EC30d644B5A86486',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xC31dB2E710192791b65dE43D4B84886A6d770322',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x11a661DEeE632244eBDD936B1784F4fd1cbbE364',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xc5B67F12BEaA7B7a106a4eDdDdc0D88635223915',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x7a264BDFb706f4299822E21Da7b19Cf0822F0afC',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xf6b25A5dCB117E524C8C7355af90886286E9f33d',
    amount: BigNumber.from('2360000000000000000'),
  },
  {
    account: '0xbD6F5BdC401AB1Ca811e40755f4A2ddAd75cE2cc',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x7a22E7a4d912231f9c0FB6760c59Ab560188360b',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x2f193b7e2a44CaeDa1AB1CcfB88840A685492F2F',
    amount: BigNumber.from('363640000000000000'),
  },
  {
    account: '0x0408dC9f4790D5cd7d8C351D17D559fCaB80F987',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xfBdD5C349D1686d7B15B27f47217c55fE93D2bfc',
    amount: BigNumber.from('1638670198115510000'),
  },
  {
    account: '0x14B802407E24fEfFc77B75eaa45c1213e5C0E0D9',
    amount: BigNumber.from('2038033589743590000'),
  },
  {
    account: '0x096616C9795018fd78CeA3835Abb40D2d63AFeb9',
    amount: BigNumber.from('760000000000000000'),
  },
  {
    account: '0x6f454FA5C8c9dC56209f6f5D4c7dF32c735C4946',
    amount: BigNumber.from('1080002098000000000'),
  },
  {
    account: '0x2915F92006F5a679C4fa6b88c4aA6fE951E91381',
    amount: BigNumber.from('1813179166400000000'),
  },
  {
    account: '0x549C0421c69Be943A2A60e76B19b4A801682cBD3',
    amount: BigNumber.from('12874541549663900000'),
  },
  {
    account: '0xa8de8B84c4F4aab4BD90447872c48b6522dEF7DC',
    amount: BigNumber.from('779464102564103000'),
  },
  {
    account: '0x528Bad3C22874E8a9bb49689aa876F76f631e07d',
    amount: BigNumber.from('1211931461736200000'),
  },
  {
    account: '0x22A15a889D5B8647Af2F55c0b2cC4087F6C5e9Db',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x9b0c19000a8631c1f555bb365bDE308384E4f2Ff',
    amount: BigNumber.from('3130640512820510000'),
  },
  {
    account: '0x7263198C709A456CfDB9d968c9EC56dfb111E5B2',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x9c22d83FB0315263566740d018f08e8c075FC927',
    amount: BigNumber.from('1275870000000000000'),
  },
  {
    account: '0xd16FDA96CB572DA89e4E39B04b99d99A8E3071fB',
    amount: BigNumber.from('1223122233429410000'),
  },
  {
    account: '0xa33c7f924399b59A8Ee627388A108beAb5E12EaF',
    amount: BigNumber.from('3687375897435900000'),
  },
  {
    account: '0xE96c3E1D842BEcCB10BF57c453B84Bf75725241D',
    amount: BigNumber.from('1600000000000000000'),
  },
  {
    account: '0x7f62Fbb8a9E707e44A198584ae2e8Db67cEfC30a',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xF0918AB646b7771d030C0643a53cD1A774139529',
    amount: BigNumber.from('1091948000000000000'),
  },
  {
    account: '0x8335bff7cE4Cdbd37bAf0aAE5BdDbD58aB0F6854',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x314Ae9291C2e1b43a6f8B68Ba7224c0b77A55dE5',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x358De7BAE44025257EAE6dd2d9774E7CbDbeEeb2',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x2aE1d88af6d27Cdf7c5c3799c8bF88191e2686D6',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xEe6cE216ceE9744BDc64cFB1c901d923d703b539',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x6496B57Cd93c607527b418EF584a6b293b80a718',
    amount: BigNumber.from('253813890000000000'),
  },
  {
    account: '0x292b78a5AD6214971c0ec79Cb9d7eb3Cf20957Fb',
    amount: BigNumber.from('662310256410256000'),
  },
  {
    account: '0x35a77CF58012d4A5F9acf8A65D9dE360355D1090',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x804F4b68D6C42b38Ba0e67cf2ae69ea9A05E189f',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x958BC7F87992791e89A5cFe764Ff5541f6329642',
    amount: BigNumber.from('480003969600000000'),
  },
  {
    account: '0x949b82Dfc04558bC4D3CA033A1B194915a3A3bEE',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x98D539aE90481E921fd9fb826500F2aF06337555',
    amount: BigNumber.from('2599078461538460000'),
  },
  {
    account: '0x049940FeDA4277b7F01eF10fCA0B975c541D8Fca',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xC49b6C714feaF22b12eB02A01521dAb6EDd1fCbd',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x1A4Ea017BbCdA7c0E79Cd9e1Ee8637b083088ae2',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xf7476Db5B717aC661C027e684456115ab1e728C3',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xa03D1648Be58e6957C81C1C201236E189b6eE6AF',
    amount: BigNumber.from('2407908184327330000'),
  },
  {
    account: '0x8CA085D6F8111B24F9e3d3584E28726ad3aAA940',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xc67a5aec18d39D925B803BF06b6D232919E9EF09',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xF83542b42Df0aA4bEe2006D3c03F8C80Cd815a18',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x7cB9ed2a2BeD605Dd5B53A86291111862553f2cb',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x9E42f20Ad23FeDa0cCa899abe688bcee67cc4D5A',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x0206Bc8FC7C1e8635D14F73c0fdb035493F2FD84',
    amount: BigNumber.from('1125978205128210000'),
  },
  {
    account: '0xB5a790758Cdb6644305d1Cf368b67bbbA4c9a68C',
    amount: BigNumber.from('1455590000000000000'),
  },
  {
    account: '0x38dAEa6f17E4308b0Da9647dB9ca6D84a3A7E195',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xD71C552a4954673a30893BF1Db0A77f1aFA1accD',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x851Af2731E1Fb915E95f0b84d472FaF44BD3583b',
    amount: BigNumber.from('1795181025641030000'),
  },
  {
    account: '0x750c31d2290c456FcCA1c659b6AdD80e7A88f881',
    amount: BigNumber.from('5703432069816440000'),
  },
  {
    account: '0x825e538A8Cd4D1Ccf42f0974f69003f91Fe4c9C3',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x648AD6f58367B42Ba3EfAb45B220528E4F180437',
    amount: BigNumber.from('6347007382712970000'),
  },
  {
    account: '0x33d20F06b0021E9013F39D8F0dca1ff8BAe0A15c',
    amount: BigNumber.from('1326427405008320000'),
  },
  {
    account: '0x8375A41C445df074709eEFA1F4AEfEE5B8b15c59',
    amount: BigNumber.from('1861488000000000000'),
  },
  {
    account: '0xe02D332b375d2437F406DbD340f954f4Eff4B230',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xd829B67e1D4d24C5947031efcddA28388612E9b2',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xb8d7b045d299c9C356bc5ee4fE2dDdC8A31280a5',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x6Cf7538744Dc6a1416Eb2A9dfd2daf2C9A829832',
    amount: BigNumber.from('1455590000000000000'),
  },
  {
    account: '0x1da75Fb0DA32653Fdab9DdecDb42F2ed61F8A28b',
    amount: BigNumber.from('1861180769230770000'),
  },
  {
    account: '0xE15494E529D8CE5A9B37Ad51bd082A884cf3Fa74',
    amount: BigNumber.from('1455590000000000000'),
  },
  {
    account: '0x43D9C66ae6D757951D21A27576490161e1438756',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xA4Db6e848f1C4aF89D2d4D4cC350Acbc1F5F93E3',
    amount: BigNumber.from('7674246874712970000'),
  },
  {
    account: '0x2fE55b3352C06C11CA7ECf7B38bD2104EE5434d3',
    amount: BigNumber.from('1083600000000000000'),
  },
  {
    account: '0x24B3b1FB8Dab66a374B93D50429665D5548B6920',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xE6Edab836662A5A9F8624f3aa4c12a53595Ebb56',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xdE708DEcb61D06eE30a95051DD203f43e0D44c70',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x33eBB62DC9ddBf6B8F3C0efdF5BccC2e7AC60211',
    amount: BigNumber.from('4424996402826130000'),
  },
  {
    account: '0x82e4D78C6c62D461251fA5A1D4Deb9F0fE378E30',
    amount: BigNumber.from('1275870000000000000'),
  },
  {
    account: '0x0353c1d821B32A59449355B4033213a6F7B8d1cb',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xF6Ed8Ca289b62Bf273baDFbAe3F4dcd915f17F48',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0xF9989443b374A81656855d2960151E0614A331e3',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x4eC5b02a9F109D44AfA67615A5A2C9A02A77e08b',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x6110Aef5CAA6C6c0cc0A30Ae20C124ffCCd49499',
    amount: BigNumber.from('2004180000000000000'),
  },
  {
    account: '0x6F21547e4D0265f7c0428d388a22cA7C54A6beAb',
    amount: BigNumber.from('2366820000000000000'),
  },
  {
    account: '0xE175A11F7Af6CeD6930d74244CFD4CF7B443A855',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xC4EA745A21C7Cc9e6E7B2384996b6B312Db8c7c1',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x2F486cD2711fed55ecc481a5a0aC62001EbFB16c',
    amount: BigNumber.from('403239418800000000'),
  },
  {
    account: '0xd56EE5Ba5A52e15f309108BDd6247C69B4F624C2',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xE9C2EEa0cC009Abc4eC3d8e48E878EBf5730755d',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xcFCa8f21F164c29F87B5cb06D5Ad938AE565Ca11',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xF99cCF26AaD027bBd11f1ebF8392BA729a454015',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x2669A693ebdF20b1333dCC8Ef892Fd9AE52d3aE9',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x7e98eBf97dc93789A7EBaa75Fe7b5d8F79C9FE26',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0x9d3F4EEB533B8e3C8f50dbbD2E351D1BF2987908',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x26A61f235B88c32b3B2BA9053e28040Da12481Ac',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x927054bEfeE8d13Bc2DAd3a54352874D4CF0ea63',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x1333c53A798547126Ca04647BA925485A6FA7Aad',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x09E6D9a4C98cFD9f990437Aa19b0a38B55336109',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x489C637ddf8EF6d9D36F776c58b898A180F08A43',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xb8F2d36d215312a918DE277dC85947cD7e01557a',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x9a11d1D90AfB58a22C566EC63f5b3A7554970aC1',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xAb79c9Fd6B7B34b24705DE49fcB848000f31D858',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0x1B5619ea5C5F0998006Af5592f2D9506F044d107',
    amount: BigNumber.from('1275870000000000000'),
  },
  {
    account: '0xf69f7faf5fdc1268d0911C08A1e51cC8738A642a',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x896b94f4f27f12369698C302e2049cAe86936BbB',
    amount: BigNumber.from('19815094291155800000'),
  },
  {
    account: '0x0C30a911CfEe90172dba6533DA18593C9F04F807',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x3dD48AD861F0B77D1312F9C95A13e52871Ca95e0',
    amount: BigNumber.from('1167543601937940000'),
  },
  {
    account: '0xfccBA075a3f25208439E8F1a9e00a87fb861e248',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xdebC0D58526D6c0db42032B43e2341A4458D6594',
    amount: BigNumber.from('2573891652035440000'),
  },
  {
    account: '0x0ae3E9B076F0FA63A818e73e6b44231908629A9e',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x2bbF6c4F339C26231bD4FC6EB4b8c3DcdFcB2250',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x758c32D2F0B32D3e0EA1e8D0D24696fe9B69D148',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x8Be8247EF3A329b06cF3ce3D5B8AD3cA3Ed642C0',
    amount: BigNumber.from('2874705773487180000'),
  },
  {
    account: '0xB9b8EF61b7851276B0239757A039d54a23804CBb',
    amount: BigNumber.from('1341950000000000000'),
  },
  {
    account: '0x0a5aF714DED4827A0891Ef9d2Eb89Ac84aD15fEa',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0xe4fb9ca52E39B83BE69E74E7Fac8f807A9c16eF9',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x6103A9e1ccB543E7488283C11B220943c7F85CF5',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x1cDb54AB57753051be5502c8376e77E74B5E2d50',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xd35Dc42C3812acE3d313f8303114B731D428a0fa',
    amount: BigNumber.from('2027150030833980000'),
  },
  {
    account: '0xFf18d10f5d9797d18DFE85437D3e76475025c2e1',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0xe164644e1e8Bb14BA8aA19be1B78ec6CF22F7ca8',
    amount: BigNumber.from('2004180000000000000'),
  },
  {
    account: '0x10a8bdA4459B8ED79529B59C5C9a6b6a530bC5E5',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xA6B49397ce21bb62200e914F41BF371E5940Bb41',
    amount: BigNumber.from('2512159709430380000'),
  },
  {
    account: '0x27e1317C497D423B6D7Ab98d006AFE5197D9591E',
    amount: BigNumber.from('2415420516675760000'),
  },
  {
    account: '0x197F8EAB3827903B011a303601Ee6DD363e3F8eF',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xA79e31F9Dd1EB4CA47d5034674D4701C318998aB',
    amount: BigNumber.from('1091949712000000000'),
  },
  {
    account: '0x4dA2e85D64bEcE663CCaB06E89B970b6b077f22F',
    amount: BigNumber.from('1341950000000000000'),
  },
  {
    account: '0xD6E6A9d952f56E48462092bBaDaB346e95E987A4',
    amount: BigNumber.from('7017037179487180000'),
  },
  {
    account: '0xf5dCb2a47f738d8bA39F9Fa2DdC7592f268a262A',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0x4782e2128a1b851C6cE47A5899EFb29E6F195025',
    amount: BigNumber.from('1091948000000000000'),
  },
  {
    account: '0xa7B6DdfF1ea5E83D42D0Bb4422Ff8e9C2EfB84d0',
    amount: BigNumber.from('1091948000000000000'),
  },
  {
    account: '0x10031a8001D7ac0bf507CAd46fF5E835C339d89a',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xC50EAAEE441566B4EF4F1e3270d19f24223Cddf4',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x569d4C513673F8A611Cf4DDE30563498642a8579',
    amount: BigNumber.from('2925328763795270000'),
  },
  {
    account: '0xeBC551A91D951875e570da49541d5a8bED469cF8',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x5D39036947e83862cE5f3DB351cC64E3D4592cD5',
    amount: BigNumber.from('405600000000000000'),
  },
  {
    account: '0x92D377Ca21Cbfbc4A1cdC6a767d91950D5418ED9',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xCa214150c6DF8848b2488F33f2c35f2417265798',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x166B6770f7513ee4BE7a88f7C8d250E5E8BCbfAF',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x2EFF1DeF3299e0A96c37406e6C4f0261ec29b805',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x8753Bc4c55aE8799A1A7091d0F28eA60C23d8744',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xF9F02eb35cc9F22A69DAA26bE2B1A57e3Ab4bD53',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x21109FB746F39A692fdc346FffA68488F2e9108c',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x61C90C2139b75D777ef4C0482bf166bB3cFAA8DD',
    amount: BigNumber.from('402519009600000000'),
  },
  {
    account: '0x316F99537B4Bade5EEA51073f1B7c38Dfbf69A70',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0xEC91Bd8bc3d2364c0751c60BF78421A1cd3D75e0',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x00D2D53e82A9a43AEA1A57022757d9df33A12f1b',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x4d72a61647afdECd607dF768F08e0bDBF4AbC85a',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x726CDC837384a7Deb8bbea64beba2E7b4d7346c0',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xD3802dcE7F7A54d59E7a64329d287624FF3F495a',
    amount: BigNumber.from('4324119487179490000'),
  },
  {
    account: '0xA3953352BeAb67861e5a7ffF47f36611A1fF5335',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xa1C6bf9a94E603c0C7e0559A9BBe6329137239f7',
    amount: BigNumber.from('2371509414489730000'),
  },
  {
    account: '0x9dED136C7A66A31d39f546e7c186609bed12089E',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xc1D43fa553B9fbaA95637D28d39862Dc339DB0EA',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x98e7D41CB1822Fc5e86F41C0290561cfFCF87e99',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x097Df964C10a3921133cfca8e70dF99d4951c3d3',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x5f945C3682E1e0B95AD17d9a9836fF3f6C266EA9',
    amount: BigNumber.from('1425283333333330000'),
  },
  {
    account: '0x0000000484f2217f1A64Eb6d24b5CEe446FaEAe5',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xF7f502609de883a240536832E7917db9eE802990',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x378F16A4c82fEDF72d3195D4969fbC9426974657',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x0F183746C22E6eA8152bEA4f59ace97ca2d6A2f2',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xeC89639d883A9Ff2086c6DEb0d766064B5BbEa03',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xF12657e7A1e2320b85b2Dd10C5F047eB14F02517',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xcAc59F91E4536Bc0E79aB816a5cD54e89f10433C',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x6f9BB7e454f5B3eb2310343f0E99269dC2BB8A1d',
    amount: BigNumber.from('2995300311261570000'),
  },
  {
    account: '0x6E93Ebc8302890fF1D1BeFd779D1DB131eF30D4d',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x6916683aB95b955bb73caF8BAB92700a2469d758',
    amount: BigNumber.from('1095526062124310000'),
  },
  {
    account: '0xA9Fb6355997aAe4A717d9bD15E60EdF26CF55c8A',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xbbcb54119492581766c1256ffbE8F816C13f26E2',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x35848Fc8cBD1C6032FF441af5520dE66Eb75BCE2',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0x9525603189Bc828B3af9de9454A79D9566E6e2fb',
    amount: BigNumber.from('3072291866858670000'),
  },
  {
    account: '0xDfb9bc53b37b3bd28836917eF6AbFab01F974421',
    amount: BigNumber.from('2394327216496080000'),
  },
  {
    account: '0x85591bFABB18Be044fA98D72F7093469C588483C',
    amount: BigNumber.from('1861490000000000000'),
  },
  {
    account: '0x13faf5475DE4BecFa376F4d540C0F7831b88B903',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x1074d44BDd446b224691C752b0e9f85c92C4D787',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xC8D46eb7881975F9aE15216FeEBa2ff58E55803c',
    amount: BigNumber.from('2360000000000000000'),
  },
  {
    account: '0xA7B38160A6e7126C5c694d3d50cB121A89Adf2aF',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x327446Dd2E6eC9F08D33573B493FBd881989EEe9',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xF0462427A46a36baA325f4BbD3789209116CDbe0',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0x40D175ca198474Bbdf8258dd9f512eC40D083772',
    amount: BigNumber.from('1091950000000000000'),
  },
  {
    account: '0x39934f0a14AA55aB28C569E6D5adBa3349eBf823',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0xAa039CCea6F5D6A15feAed241a3f2ECAEd62DB10',
    amount: BigNumber.from('405900000000000000'),
  },
  {
    account: '0xCC55AA8FA576A0217523f62083eC633b9a04af01',
    amount: BigNumber.from('2367600000000000000'),
  },
  {
    account: '0x2c588125082e49ffBb59b0c209654f6cBcF19F6E',
    amount: BigNumber.from('769540000000000000'),
  },
  {
    account: '0xb90781Ceb500f80A9c101225eD5451449a3Aa5bc',
    amount: BigNumber.from('2367820000000000000'),
  },
  {
    account: '0x3eF7f258816F6e2868566276647e3776616CBF4d',
    amount: BigNumber.from('12051282051282100000'),
  },
  {
    account: '0x4c46f9a3Da4F7F2911e29dae334ebCf09101a669',
    amount: BigNumber.from('10588141233983700000'),
  },
  {
    account: '0x002A5dc50bbB8d5808e418Aeeb9F060a2Ca17346',
    amount: BigNumber.from('10256410256410300000'),
  },
  {
    account: '0x0EB4ADD4bA497357546DA7F5D12D39587cA24606',
    amount: BigNumber.from('10256410256410300000'),
  },
  {
    account: '0x376955C79B654e1F80733D127394d8008e953882',
    amount: BigNumber.from('10436432514329600000'),
  },
  {
    account: '0xC1fc118D52e4Bc0A257F6744c77A611ad09f7777',
    amount: BigNumber.from('9668350717111130000'),
  },
  {
    account: '0x1ad015A04C3a21330a388f6a0995c7C092E66F93',
    amount: BigNumber.from('9657939660683450000'),
  },
  {
    account: '0xF50F1f8635823Ac38A3f36af4478fFa8a2810424',
    amount: BigNumber.from('8648305641025640000'),
  },
  {
    account: '0xe5D0Ef77AED07C302634dC370537126A2CD26590',
    amount: BigNumber.from('7692307692307690000'),
  },
  {
    account: '0x66F932Ad6d530603ca9c95AAa9eD6348cBbf018E',
    amount: BigNumber.from('7895391999043880000'),
  },
  {
    account: '0xD4F513A3A8Db3AB5cAa1a5B4c8cE812893B32760',
    amount: BigNumber.from('6568178027584080000'),
  },
  {
    account: '0xB5fC9EEf8f391051ECfC1c7d71D617181A56539B',
    amount: BigNumber.from('5805912052739760000'),
  },
  {
    account: '0x1C051112075FeAEe33BCDBe0984C2BB0DB53CF47',
    amount: BigNumber.from('5128205128205130000'),
  },
  {
    account: '0x14A03CA8740A0044E63d3Bb0432540d9509473d1',
    amount: BigNumber.from('5350109460970690000'),
  },
  {
    account: '0xEde81dBF541e36F47E8Af619Efa3Fe701B606915',
    amount: BigNumber.from('4653879921452250000'),
  },
  {
    account: '0x1FE9Fd1156688699F4ca017E72ee0D9873f9d758',
    amount: BigNumber.from('4403290256410260000'),
  },
  {
    account: '0x0B1FDB90501286ebe6087b6660C3a48db9898FAD',
    amount: BigNumber.from('4202410769230770000'),
  },
  {
    account: '0xa8d25C5A6f832a9423038c86529391aA7B7F91a0',
    amount: BigNumber.from('4426850576317560000'),
  },
  {
    account: '0xd30391E21741C54c32987bCfcA3D880E6D261Cb0',
    amount: BigNumber.from('3814164809286400000'),
  },
  {
    account: '0x7B6d03eda08626BbfF1aBdf1340B999670e1fc28',
    amount: BigNumber.from('3298565198895590000'),
  },
  {
    account: '0xe65964de92D2d2540e73388B1037c964674D572b',
    amount: BigNumber.from('3231155763779200000'),
  },
  {
    account: '0x6eF3f0fF397C3de367C6cA2Cc3e6B6955E7993A5',
    amount: BigNumber.from('3215342745148640000'),
  },
  {
    account: '0xa18669587490522d0e3c67464C8d4cad22405AFc',
    amount: BigNumber.from('2999865312247430000'),
  },
  {
    account: '0x86282513581c5295Ab5157876E7687FC20deA071',
    amount: BigNumber.from('2924102565230770000'),
  },
  {
    account: '0x36F22F65a3476F42f6Ae813DA097Dd471FcADEb1',
    amount: BigNumber.from('2712296046481390000'),
  },
  {
    account: '0x2f45724d7E384b38D5C97206e78470544304887F',
    amount: BigNumber.from('2826513815677050000'),
  },
  {
    account: '0x3ea4C7dc4aAbb87267073729FF4D1b529469931c',
    amount: BigNumber.from('2688424615384620000'),
  },
  {
    account: '0x7e346f31a13D0a142885ff1A9494829947B48372',
    amount: BigNumber.from('3370060275827910000'),
  },
  {
    account: '0x8506970Ca968367E87c225C2F63C0A26F5AEad24',
    amount: BigNumber.from('2564102564102560000'),
  },
  {
    account: '0xF5eC36a06475AeC69FA289053963FA6473802AB4',
    amount: BigNumber.from('2645696589942440000'),
  },
  {
    account: '0xC02ad7b9a9121fc849196E844DC869D2250DF3A6',
    amount: BigNumber.from('2519943076923080000'),
  },
  {
    account: '0x20EADfcaf91BD98674FF8fc341D148E1731576A4',
    amount: BigNumber.from('2359091520304490000'),
  },
  {
    account: '0xDf7632EA06b068D7a249f465379D0d549290b1cd',
    amount: BigNumber.from('2220112820512820000'),
  },
  {
    account: '0xf49d2bcC52F0b46a98204721f98Ce9d4e6730BEd',
    amount: BigNumber.from('2284991284553580000'),
  },
  {
    account: '0x91cAaB3C0e9111043C97F5B3F10f614A193a11C9',
    amount: BigNumber.from('1964602008820510000'),
  },
  {
    account: '0x1dA158559F54d81B13dda7b9602cB5E09468aC09',
    amount: BigNumber.from('1925658659515430000'),
  },
  {
    account: '0x3dA9D70305B83Db1f545A5d50B19208b93cD0C21',
    amount: BigNumber.from('1900435910199070000'),
  },
  {
    account: '0x23783f2d297555Fdcbd3CdA4b4cEe5af9DD2a02b',
    amount: BigNumber.from('1629590004520410000'),
  },
  {
    account: '0xE3939654Deae5f54fD3e6B84b3A7F75f245062d8',
    amount: BigNumber.from('1709148394163680000'),
  },
  {
    account: '0x000B79f52356189C80a9d3AdA3911D4438218516',
    amount: BigNumber.from('1523682564102560000'),
  },
  {
    account: '0x70aD81d18F2838b8650D88740d8E337032c9BaAC',
    amount: BigNumber.from('1486776348032640000'),
  },
  {
    account: '0x4e9C104d24cA8aA27c3e1A5d9D3249e96c5bbD80',
    amount: BigNumber.from('1438508205128210000'),
  },
  {
    account: '0xFFfe1F5D42DC16AF7c05D0Aa24D2C649A869B367',
    amount: BigNumber.from('1660491214177170000'),
  },
  {
    account: '0x678fb21b9736e6c7Da9f7d37a77Ab766bb2519c7',
    amount: BigNumber.from('1349294871794870000'),
  },
  {
    account: '0x64B55f553a7648e8bCc1bD99136708d3F37917C5',
    amount: BigNumber.from('1331181538461540000'),
  },
  {
    account: '0x2f5691bC4D8db66908BE10fad913fDc91c99Ce9F',
    amount: BigNumber.from('1330031867026780000'),
  },
  {
    account: '0x06fB3FD7a77274aA9ac0d2b0Bc58A9AC9332D4ba',
    amount: BigNumber.from('1428058200377370000'),
  },
  {
    account: '0x1793CD5916cC6f5b20593e001A1cC3B66268da1f',
    amount: BigNumber.from('1294516809131950000'),
  },
  {
    account: '0x76bbd639c87AaC623Aad1c3b648E6187A9392DEA',
    amount: BigNumber.from('974886153846154000'),
  },
  {
    account: '0x76cea8d9D3817FE361e1C1d32081F7c1dDB6aAae',
    amount: BigNumber.from('934858974358974000'),
  },
  {
    account: '0xbE79665B3Dcecfe1DD821f8714bc9bfc441ef92A',
    amount: BigNumber.from('906801025641026000'),
  },
  {
    account: '0x36837e2c2893b2d34fA80694B70eb53677aa6D4a',
    amount: BigNumber.from('849768205128205000'),
  },
  {
    account: '0x563e8cB3055A3cc0502DC6D603F6dad21E1438Ea',
    amount: BigNumber.from('893853294859817000'),
  },
  {
    account: '0x69EF38D5A4ffb93579698b457622E8eB42CC4258',
    amount: BigNumber.from('829426666666667000'),
  },
  {
    account: '0xEDF7b675a2fE3c27efb263fb4c204A3f0fb17D46',
    amount: BigNumber.from('813262209128205000'),
  },
  {
    account: '0x89B8992AEc28D34eD8579fDe2b10B872DD26e617',
    amount: BigNumber.from('891726843505244000'),
  },
  {
    account: '0x5FbD75846A90e965feFaCFE5D80e8e2bA675D841',
    amount: BigNumber.from('769230769230769000'),
  },
  {
    account: '0x5ef4Fd1D0f921550104E2a539eEed1f2092d54A1',
    amount: BigNumber.from('745526487487598000'),
  },
  {
    account: '0xBe289902A13Ae7bA22524cb366B3C3666c10F38F',
    amount: BigNumber.from('793661642229216000'),
  },
  {
    account: '0x2E15D7AA0650dE1009710FDd45C3468d75AE1392',
    amount: BigNumber.from('666950806820513000'),
  },
  {
    account: '0x5993Bad196C8786BaAEdB5A5868f338fE6ce4Cc2',
    amount: BigNumber.from('699902754433065000'),
  },
  {
    account: '0x2bEBa030cdC9c4a47c5aa657974840428b9fEfAc',
    amount: BigNumber.from('601081295282051000'),
  },
  {
    account: '0x9a49Fa38d835248225Bf5Eb18E7624430518A99D',
    amount: BigNumber.from('555202932884899000'),
  },
  {
    account: '0x9057e3B928E0b0b9cA2767a68538B3ADB290bc85',
    amount: BigNumber.from('512820512820513000'),
  },
  {
    account: '0xD0C231A8DEC99bA56fC2F58C0785557FDAf4059E',
    amount: BigNumber.from('512820512820513000'),
  },
  {
    account: '0x7b6C0F34898878f2C9F0cA97D6E4494E15Ccb1C6',
    amount: BigNumber.from('520146009527132000'),
  },
  {
    account: '0xcE7aa2D3C1F8B572B50238230f5D55A78dB86087',
    amount: BigNumber.from('502535312923077000'),
  },
  {
    account: '0x13DbAd5d734Da7be69e6d91Aa6650df7D41DBbd1',
    amount: BigNumber.from('477362564102564000'),
  },
  {
    account: '0x268bc10A917438c7683823e195acD933aB43187a',
    amount: BigNumber.from('473256420461539000'),
  },
  {
    account: '0xb22E5Cadb0E487Aa335ab99818f5E1B5C0B96260',
    amount: BigNumber.from('483094973449272000'),
  },
  {
    account: '0xda248cC10b477C1144219183EC87b0621DAC37b3',
    amount: BigNumber.from('501361629937515000'),
  },
  {
    account: '0x1fb36B64649E6D55E100B31D8113cc0F7DD82592',
    amount: BigNumber.from('507468324438218000'),
  },
  {
    account: '0xFC5CC7832B2C0938Fe698D1bBd68D578A114bE09',
    amount: BigNumber.from('432401025641026000'),
  },
  {
    account: '0x2D7Baa2B939d6f7B38A1CB582B46Da2f71a42d1F',
    amount: BigNumber.from('421884157384615000'),
  },
  {
    account: '0x03f02D33cC02E006Cb25F7c7bFE3115EE6B55283',
    amount: BigNumber.from('410736923076923000'),
  },
  {
    account: '0x3150e3D0b3F1Dd76d753f67c28D053458d098053',
    amount: BigNumber.from('393384615384615000'),
  },
  {
    account: '0xEB85A4fFA6A194BCDE4Befd2eecAbd4F65C3F8C4',
    amount: BigNumber.from('376695384615385000'),
  },
  {
    account: '0x278BA1Da4e4ff2541234F19487fd94A12061CA55',
    amount: BigNumber.from('374702564102564000'),
  },
  {
    account: '0xC102d21DA143Cb144bbdc4693553a850CF73cA5f',
    amount: BigNumber.from('364745128205128000'),
  },
  {
    account: '0x00C67d9D6D3D13b42a87424E145826c467CcCd84',
    amount: BigNumber.from('333290256410256000'),
  },
  {
    account: '0xfc436651F2fD4885AD645035a63A7Cd22E6A868c',
    amount: BigNumber.from('329097435897436000'),
  },
  {
    account: '0xDd4a7cc4092515C130667C1bFd53Be0DE91062C5',
    amount: BigNumber.from('307743589743590000'),
  },
  {
    account: '0x9AbbEd91faC6e71977258Fa8aa949c9bD874F4DE',
    amount: BigNumber.from('337802835116350000'),
  },
  {
    account: '0x9a568bFeB8CB19e4bAfcB57ee69498D57D9591cA',
    amount: BigNumber.from('247679487179487000'),
  },
  {
    account: '0xF7B10D603907658F690Da534E9b7dbC4dAB3E2D6',
    amount: BigNumber.from('244927692307692000'),
  },
  {
    account: '0x883Ab2aE1BDDa0531078b27dd45600193aba1F34',
    amount: BigNumber.from('188960512820513000'),
  },
  {
    account: '0x8f9bE4310f9AbB0E5843Cc6363908C9B01dfeB3F',
    amount: BigNumber.from('171097948717949000'),
  },
  {
    account: '0x89E7d093d04d267BEd0639542823cc3286E2FAA7',
    amount: BigNumber.from('166666153846154000'),
  },
  {
    account: '0x9E7943cEAc1f02B00E5f9d6E182F257efaA4653e',
    amount: BigNumber.from('158705641025641000'),
  },
  {
    account: '0x0e41c9B548cf0545377AEEb693A6006172F1af81',
    amount: BigNumber.from('201249851637105000'),
  },
  {
    account: '0x2B2F2A9302Cdecdb7D4A2e7005336f7B345C1092',
    amount: BigNumber.from('147958461538462000'),
  },
  {
    account: '0x9b3f49A186670194f625199B822FCbDFD3Feacf7',
    amount: BigNumber.from('147184102564103000'),
  },
  {
    account: '0x62A32ea089109e7b8f0fE29d839736DDB0C753F6',
    amount: BigNumber.from('147156148460882000'),
  },
  {
    account: '0x237ec64cC27196F6a4C16AbdBb558B4C518400C2',
    amount: BigNumber.from('141681350895602000'),
  },
  {
    account: '0x14b889B25e70f60D8Dc0aa5F10c83680add61351',
    amount: BigNumber.from('127974358974359000'),
  },
  {
    account: '0x605D50F68E737eBF7F6054D6f7860010FC80971F',
    amount: BigNumber.from('100390256410256000'),
  },
  {
    account: '0x82974862229A33eB52aF17AA28aF96a85D719E2c',
    amount: BigNumber.from('100252871500265000'),
  },
  {
    account: '0x0154d25120Ed20A516fE43991702e7463c5A6F6e',
    amount: BigNumber.from('97109230769230800'),
  },
  {
    account: '0xdAF6f97E24b4071c475Ff2A46B258C207Ffb5392',
    amount: BigNumber.from('91282051282051300'),
  },
  {
    account: '0xCa41730A221Aa83d2849Be36163DC301d0F053A8',
    amount: BigNumber.from('87764973211356700'),
  },
  {
    account: '0xb28037800F282E7A96a79fD0b0B5c1EED64bAaD2',
    amount: BigNumber.from('74973333333333300'),
  },
  {
    account: '0xD1a059Ae2eA4E6f4329dbd54a71A8ccF5d888d6B',
    amount: BigNumber.from('69397049167304900'),
  },
  {
    account: '0x7E4F1A12269C55d23c50e91017876D8A0B2ef14C',
    amount: BigNumber.from('69607448089127600'),
  },
  {
    account: '0x5BFA69517E17411bEDA54ea2d3672709F4867254',
    amount: BigNumber.from('75732626292276000'),
  },
  {
    account: '0x2FeD28677601cF6cb669A3cE424119bb1BA69eC0',
    amount: BigNumber.from('53501569630914500'),
  },
  {
    account: '0xd3B2a586180c9e306b38848D31e82F9E17D76F0C',
    amount: BigNumber.from('52244507538461500'),
  },
  {
    account: '0x156d27E5248eFe83Ccf74D934FC396e03F7685be',
    amount: BigNumber.from('49394390553613700'),
  },
  {
    account: '0x7566fd09eD636e132BDaaF4Fc8Ddd5eF1FBc5c14',
    amount: BigNumber.from('47058461538461500'),
  },
  {
    account: '0x9581F442075Eef408Bd5e560CCA77Fcf598f601e',
    amount: BigNumber.from('76605287024314100'),
  },
  {
    account: '0xDF77257cA98DfAEF7d66FaF85Cf5a212849bAf25',
    amount: BigNumber.from('41143076923076900'),
  },
  {
    account: '0xBD1f7d88C76A86C60d41bDDD4819fAe404e7151E',
    amount: BigNumber.from('42603785870664400'),
  },
  {
    account: '0xbbe21151c726F9EEc42516524f58D0057261CC8a',
    amount: BigNumber.from('40005326051282100'),
  },
  {
    account: '0xf695d9975Efd23d809d8857438c1aB6B3D09650f',
    amount: BigNumber.from('38590769230769200'),
  },
  {
    account: '0x922e1ce088bB4Fc0295d992070B65088307957e2',
    amount: BigNumber.from('30124102564102600'),
  },
  {
    account: '0x6ab791754298D6D6d7C182DC1572126B4eD24897',
    amount: BigNumber.from('34350419844332300'),
  },
  {
    account: '0x18f768455E7f5fB09fC491fd86bcc282BcDD5973',
    amount: BigNumber.from('26282564102564100'),
  },
  {
    account: '0xF71EB59210eed86E727d76f434A2694238213dEB',
    amount: BigNumber.from('34460303285212200'),
  },
  {
    account: '0x8F844D3C0C06526387fA01d165Fba8C3984Efdac',
    amount: BigNumber.from('23076923076923100'),
  },
  {
    account: '0x3195c3F94154364E897711e501e104f40D8e23fb',
    amount: BigNumber.from('45826666666666700'),
  },
  {
    account: '0x3bd5e344Ac629C9f232F921bAfDeEEc312deAC9b',
    amount: BigNumber.from('25568349555104300'),
  },
  {
    account: '0x3D16451A4B73e778BFEC126025bA79716a17E32d',
    amount: BigNumber.from('16917948717948700'),
  },
  {
    account: '0xaF34FeaC2Fb7449b745bC79046aD0CECd8bC159d',
    amount: BigNumber.from('34680512820512800'),
  },
  {
    account: '0xe734F1270098fC0E3A978da32887ccf0339ba99a',
    amount: BigNumber.from('7923076923076920'),
  },
  {
    account: '0xA178c15dd95553da5b79c1BA0bDE1659Fa2e76c8',
    amount: BigNumber.from('6276923076923080'),
  },
  {
    account: '0x06DD6783C388b7B3080a8E0D3A3bFB8C07A6D1dF',
    amount: BigNumber.from('1034890632852840'),
  },
  {
    account: '0xF6E2c94A609Ca303964b65EC991A1A0d2991B961',
    amount: BigNumber.from('512820512820513000'),
  },
  {
    account: '0xFEC18996C36D02902E4c55bcFB7A1c73AA1500Cd',
    amount: BigNumber.from('250000000000000000'),
  },
  {
    account: '0xd40428c28badB95783fb4762b3e36f448ADca44D',
    amount: BigNumber.from('329901003452552000'),
  },
  {
    account: '0xe519f4cd2803BA53A40E6377E82406e548418660',
    amount: BigNumber.from('179899434925762000'),
  },
  {
    account: '0x5FEDDF388f844D00Ed2774BEa879C782405AEcb1',
    amount: BigNumber.from('92100059262156900'),
  },
  {
    account: '0x1A31C94f97C649bC2a8aDbCeb54D1f4a075be4b1',
    amount: BigNumber.from('100204687832484000'),
  },
  {
    account: '0xC9420C9349120CA88D6C349CDF4Af038e2Ca5027',
    amount: BigNumber.from('6052610787653700'),
  },
  {
    account: '0x671dd102d1B9AdFD54FD365769afC37705A3CE68',
    amount: BigNumber.from('1939363944343120'),
  },
  {
    account: '0xd921ef794F9CF9e6Be1ac5aA58d3f97035924663',
    amount: BigNumber.from('61976639598683000'),
  },
  {
    account: '0xB14CF9B14db20b0B6A964d0ee7f60894e1F186DD',
    amount: BigNumber.from('2748096228853710'),
  },
  {
    account: '0xFF6d6Ae87B6431564737834BF733a13aF4B734F4',
    amount: BigNumber.from('5635505260140280'),
  },
  {
    account: '0xfc117cb4c186586f415cEbaaa0644aA0aD530B8A',
    amount: BigNumber.from('44123757860716400'),
  },
  {
    account: '0x75AfAEce8CF2a7974B1e541648923aFD9339B3f8',
    amount: BigNumber.from('72478515769517600'),
  },
  {
    account: '0x3B112dFb7D2aC2C03E7cb64AA61DAF128e546A54',
    amount: BigNumber.from('38516482095307'),
  },
  {
    account: '0x58669F50DC0F3DFfAa07182f9B14c65e63835B7F',
    amount: BigNumber.from('25000000000000000'),
  },
  {
    account: '0x62F31E08e279f3091d9755a09914DF97554eAe0b',
    amount: BigNumber.from('25000000000000000'),
  },
  {
    account: '0x9c767178528c8a205DF63305ebdA4BB6B147889b',
    amount: BigNumber.from('25000000000000000'),
  },
  {
    account: '0x2117c37a65aD3c0489682386f7d81d4c6d08B3C8',
    amount: BigNumber.from('250000000000000000'),
  },
  {
    account: '0x22ee350346F93B9191af9a70cfFA8c5746BdfD14',
    amount: BigNumber.from('250000000000000000'),
  },
  {
    account: '0x46A968F38F2Ef98Eb51cC8c8a2C641Fd47042964',
    amount: BigNumber.from('250000000000000000'),
  },
  {
    account: '0x77DA151402d33cBF3E0123B123d7b57C28d95CfD',
    amount: BigNumber.from('250000000000000000'),
  },
  {
    account: '0x975f5ffB9C3B624351634889944355D47Ab8a367',
    amount: BigNumber.from('250000000000000000'),
  },
  {
    account: '0xA007b5D85f67A4d882927ef2Ca992735a21d5028',
    amount: BigNumber.from('250000000000000000'),
  },
]
